export enum CopyMapInputField {
  Name = 'name',
}
